export const COMPARE_PERIODS_ENUM = {
  NO_COMPARE: 0,
  COMPARE_WITH_PREVIOUS_PERIOD: 1,
  COMPARE_WITH_PREVIOUS_YEAR: 2
};
